module.exports = __webpack_public_path__ + "img/developing.eb7efa6a.png";